import { useCallback, useState } from "react";
import AuthMpProvider from "@/core/data-provider/data-mp/auth/auth-mp-provider";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useErrorTranslation from "@/core/helpers/useErrorTranslation";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response";
import { setSignUp } from "@/domains/auth/slice";
import useGetSocialClub from "@/domains/auth/hooks/useGetSocialClub";

export default function useSignUp() {
  const tError = useErrorTranslation();
  const dispatch = useAppDispatch();
  const { getSocialClub } = useGetSocialClub();
  const [isPending, setIsPending] = useState(false);
  const [isCompleted, setIsCompleted] = useState<null | boolean>(null);
  const [error, setError] = useState("");

  const onSignUp = useCallback(
    async (data: { email: string; password: string; promoCode: string }) => {
      try {
        setIsPending(true);
        const response = await AuthMpProvider.signUp(data);
        if (response instanceof RpcMpProviderSuccessResponse) {
          setIsCompleted(true);
          getSocialClub();
          dispatch(setSignUp(data));
        } else {
          setIsCompleted(false);
        }
      } catch (e) {
        setIsCompleted(false);
        setError(tError(e.message));
      } finally {
        setIsPending(false);
      }
    },
    [dispatch],
  );

  return { onSignUp, isPending, isCompleted, error };
}
